import { render, staticRenderFns } from "./Advances.vue?vue&type=template&id=df80f2fe&scoped=true"
import script from "./Advances.vue?vue&type=script&lang=js"
export * from "./Advances.vue?vue&type=script&lang=js"
import style0 from "./Advances.vue?vue&type=style&index=0&id=df80f2fe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df80f2fe",
  null
  
)

export default component.exports